import React from 'react';
import { HStack, Progress, Td, Tr, Icon, Tag, TagLabel, Text as ChakraText, VStack, } from '@chakra-ui/react';
import moment from 'moment';
import { SignerStatus, } from '../../../../../../../../services/types';
import { tKeys } from '../../../../../../../../translations/keys';
import { useTranslation } from 'react-i18next';
import COLORS from '../../../../../../../../constants/colors';
import { FiFileText } from 'react-icons/fi';
// Add back the getTypeColor helper function
const getTypeColor = (typeName) => {
    switch (typeName) {
        case 'Meeting Minutes':
            return COLORS.Govrn.Blue.T500.value;
        case 'Financial Report':
            return COLORS.Govrn.PastelGreen.T500.value;
        case 'Strategic Plan':
            return COLORS.Govrn.Purple.T500.value;
        case 'SignatureRequest':
            return COLORS.Govrn.Yellow.T500.value;
        default:
            return COLORS.Text.T300.value;
    }
};
export const DocumentListTableRow = ({ document, onClick, documentRelation, }) => {
    const { t } = useTranslation();
    const doc = document;
    const typeColor = getTypeColor(doc.typeName);
    const translatedTypeName = doc.typeName
        ? t(doc.typeName, { defaultValue: doc.typeName })
        : 'Unknown Type';
    // Signature progress calculation (only needed for signature tab)
    const isSignatureTab = documentRelation.value === 3;
    let calculatedSignatureProgression;
    let signatureTotal;
    let showSignatureProgress = false;
    let isSigned = false;
    let progressPercent = 0;
    if (isSignatureTab) {
        calculatedSignatureProgression =
            doc.signers?.reduce((acc, signer) => acc + (signer?.status === SignerStatus[2] ? 1 : 0), 0) ?? 0;
        signatureTotal = doc.signers?.length || 0;
        showSignatureProgress = signatureTotal > 0;
        isSigned =
            showSignatureProgress &&
                calculatedSignatureProgression === signatureTotal;
        progressPercent = showSignatureProgress
            ? (calculatedSignatureProgression / signatureTotal) * 100
            : 0;
    }
    const isGeneralTab = documentRelation.value === 2;
    return (<Tr onClick={() => onClick(doc)} _hover={{ backgroundColor: 'gray.50', cursor: 'pointer' }} height="auto" verticalAlign="middle">
      {/* Main Content Column (Icon + Title + Tag) - Always Show */}
      <Td width="60%" py={1.5} px={3}>
        <HStack spacing={3} alignItems="center">
          <Icon as={FiFileText} boxSize={4} color={COLORS.Text.T400.value}/>
          <ChakraText fontSize="14px" fontWeight="normal" noOfLines={1} flexShrink={1} mr={2}>
            {doc.title || 'Untitled Document'}
          </ChakraText>
          {doc.typeName && (<Tag size="sm" variant="subtle" flexShrink={0} bg={`${typeColor}20`} color={typeColor} borderRadius="full">
              <TagLabel>{translatedTypeName}</TagLabel>
            </Tag>)}
        </HStack>
      </Td>

      {/* Date Column (Show Issued On - Header: "Publié le") - Always Show */}
      <Td py={1.5} px={3}>
        <ChakraText fontSize="sm" color={COLORS.Text.T400.value}>
          {doc.issuedOn ? moment(doc.issuedOn).format('L') : '-'}
        </ChakraText>
      </Td>

      {/* Conditional Column (Signature Status ONLY for Signature Tab) */}
      {isSignatureTab && (<Td py={1.5} px={3} textAlign={'center'}>
          {showSignatureProgress ? (isSigned ? (<Tag size="sm" colorScheme="green" variant="subtle">
                {t(tKeys.common.signed)}
              </Tag>) : (<VStack spacing={0} align="center">
                <Progress value={progressPercent} size="xs" colorScheme="blue" width="80px" borderRadius="sm"/>
                <ChakraText fontSize="xs" color="gray.600">
                  {calculatedSignatureProgression} / {signatureTotal}
                </ChakraText>
              </VStack>)) : (<ChakraText fontSize="sm" color={COLORS.Text.T400.value}>
              -
            </ChakraText> // Show dash if no signers
            )}
        </Td>)}
      {/* DO NOT render the third column for General Tab (or other tabs) */}
    </Tr>);
};
